import { Badge, Stack } from '@mui/material'
import { IconButton } from 'utoniq-ui'

import { Cell, CellFrame } from '@/core/architecture'

type ThumbnailActionAreaCellProps = {
  onOpenFullScreen?: () => void
  onOpenMultipleImage?: () => void
  numberImage: number
}
export const ThumbnailActionAreaCell: Cell<ThumbnailActionAreaCellProps> = ({
  onOpenFullScreen,
  onOpenMultipleImage,
  numberImage,
}) => (
  <CellFrame width="100%" sx={{ py: 2 }}>
    <Stack
      direction="row"
      spacing={2}
      justifyContent="flex-end"
      sx={{ mx: -7 }}
    >
      <IconButton.Zoom
        size="small"
        bgcolor="grey.50"
        color="grey.700"
        onClick={onOpenFullScreen}
        sx={{
          width: '30px !important',
          height: '30px !important',
          svg: { width: 16, height: 16 },
        }}
      />
      {!!numberImage && (
        <Badge
          badgeContent={numberImage}
          sx={{
            '.MuiBadge-badge': {
              top: 'unset',
              bottom: -16,
              bgcolor: 'grey.200',
              color: 'white',
              p: '0',
            },
          }}
        >
          <IconButton.Image
            size="small"
            bgcolor="grey.50"
            color={'grey.700' as any}
            disabled={!numberImage}
            onClick={onOpenMultipleImage}
            sx={{
              width: '30px !important',
              height: '30px !important',
              '&.Mui-disabled': {
                bgcolor: 'grey.50',
              },
              svg: { width: 16, height: 16 },
            }}
          />
        </Badge>
      )}
    </Stack>
  </CellFrame>
)
